export function getOrCreateVisitorId(): string {
  const match = document.cookie.match(/(?:^|;\s*)impact_profile_id=([^;]+)/);
  const existing = match?.[1];
  if (existing) return existing;
  const id = crypto.randomUUID();
  const oneYearSeconds = 60 * 60 * 24 * 365;
  const domainAttr = location.hostname.endsWith("maticrobots.com")
    ? "; Domain=.maticrobots.com"
    : "";
  document.cookie = `impact_profile_id=${id}; Max-Age=${oneYearSeconds}; Path=/; SameSite=Lax; Secure${domainAttr}`;
  return id;
}
